export default "__VITE_ASSET__53c4d3d2__"